import { render, staticRenderFns } from "./Undescribed.vue?vue&type=template&id=7951fa0e&"
import script from "./Undescribed.vue?vue&type=script&lang=js&"
export * from "./Undescribed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports